import router from "@/router/router";
export default class Menu{
    static buildMenu(){
        let routes = router.options.routes;
        let menuTree = [];
        for(let i=0;i<routes.length;i++){
            if(routes[i].showMenu === true){
                let menuItem = Menu.getMenuItem(routes[i]);
                menuTree.push(menuItem);
            }
        }
        return menuTree;
    }

    static getMenuItem(menuItem){
        let menuTree = {};
        if(menuItem.showMenu === true){
            menuTree.name = menuItem.name;
            menuTree.path = menuItem.path;
            menuTree.title = menuItem.meta.title;
            if(menuItem.children!==undefined && menuItem.children.length>0){
                menuTree.children = [];
                for(let i=0;i<menuItem.children.length;i++){
                    let child = Menu.getMenuItem(menuItem.children[i]);
                    if(child!==null){
                        menuTree.children.push(child);
                    }
                }
            }
        }else{
            menuTree = null;
        }
        return menuTree;
    }

    static buildBread(path){
        let routes = router.options.routes;
        let breadcrumb = [];
        for(let i=0;i<routes.length;i++){
            if(routes[i].showMenu === true){
                let breadcrumbItem = Menu.breadItem(routes[i],"");
                breadcrumb = breadcrumb.concat(breadcrumbItem);
            }
        }
        let breads = [];
        for(let i=0;i<breadcrumb.length;i++){
            if(breadcrumb[i].path === path){
                breads = breadcrumb[i].bread.split("/");
            }
        }
        return breads;
    }

    static breadItem(routeItem,parentTitle){
        let breadcrumb = [];
        if(routeItem.showMenu === true){
            let tmp = {
                bread: (parentTitle!=="")?parentTitle+' / '+routeItem.meta.title:routeItem.meta.title,
                path:routeItem.path
            };
            breadcrumb.push(tmp);
            if(routeItem.children!==undefined && routeItem.children.length>0){
                for(let i=0;i<routeItem.children.length;i++){
                    let child = Menu.breadItem(routeItem.children[i],routeItem.meta.title);
                    breadcrumb = breadcrumb.concat(child);
                }
            }
        }else{
            breadcrumb = null;
        }
        return breadcrumb;
    }

}
